import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

const Category_Add = () => {
    const [categoryName, setCategoryName] = useState('');
    const [categoryKeywords, setCategoryKeywords] = useState('');
    const [subcategories, setSubcategories] = useState([
        {
            name: '',
            keywords: '',
            children: [],
            showChildren: false
        }
    ]);

    const handleCategoryChange = (field, value) => {
        if (field === 'name') setCategoryName(value);
        else if (field === 'keywords') setCategoryKeywords(value);
    };

    const handleSubcategoryChange = (index, field, value) => {
        const updated = [...subcategories];
        updated[index][field] = value;
        setSubcategories(updated);
    };

    const handleChildChange = (subIndex, childIndex, field, value) => {
        const updated = [...subcategories];
        updated[subIndex].children[childIndex][field] = value;
        setSubcategories(updated);
    };

    const addSubcategory = () => {
        setSubcategories([
            ...subcategories,
            {
                name: '',
                keywords: '',
                children: [],
                showChildren: false
            }
        ]);
    };

    const addChild = (subIndex) => {
        const updated = [...subcategories];
        updated[subIndex].children.push({ name: '', keywords: '' });
        updated[subIndex].showChildren = true;
        setSubcategories(updated);
    };

    const removeSubcategory = (index) => {
        const updated = [...subcategories];
        updated.splice(index, 1);
        setSubcategories(updated);
    };

    const removeChild = (subIndex, childIndex) => {
        const updated = [...subcategories];
        updated[subIndex].children.splice(childIndex, 1);
        setSubcategories(updated);
    };

    const addChildAt = (subIndex, position) => {
        const updated = [...subcategories];
        updated[subIndex].children.splice(position, 0, { name: '', keywords: '' });
        setSubcategories(updated);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const mainCategoryRes = await authManager.authenticatedFetch(`${Base_Url}/shopping/categories`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                name: categoryName,
                description: '',
                parentId: '',
                keywords: categoryKeywords.split(',').map(k => k.trim())
            })
        });

        const mainData = await mainCategoryRes.json();
        const parentId = mainData?.result?._id;

        for (const sub of subcategories) {
            const subRes = await authManager.authenticatedFetch(`${Base_Url}/shopping/categories`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: sub.name,
                    description: '',
                    parentId,
                    keywords: sub.keywords.split(',').map(k => k.trim())
                })
            });

            const subData = await subRes.json();
            const subId = subData?.result?._id;

            for (const child of sub.children) {
                await authManager.authenticatedFetch(`${Base_Url}/shopping/categories`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        name: child.name,
                        description: '',
                        parentId: subId,
                        keywords: child.keywords.split(',').map(k => k.trim())
                    })
                });
            }
        }

        alert('Category structure added successfully.');
    };

    return (
        <div>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2 align-items-center">
                        <div className="col-6 col-sm-6">
                            <h1 className="m-0 txt_lft">Add Category</h1>
                        </div>
                        <div className="col-6 col-sm-6">
                            <ol className="breadcrumb justify-content-end">
                                <Link to="/category">
                                    <i className="fa-solid fa-arrow-left-long" /> Back
                                </Link>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="frmwdth_cntr">
                            <div className="col-lg-12">
                                <div className="card card-primary card-outline">
                                    <form className="form-horizontal" onSubmit={handleSubmit}>
                                        <div className="card-body">
                                            <div className="form-group row">
                                                <label className="col-12 col-md-4 col-form-label">Category</label>
                                                <div className="col-12 col-md-8">
                                                    <div className="mb-2 w-100">
                                                        <input type="text" className="form-control" placeholder="Name" value={categoryName} onChange={(e) => handleCategoryChange('name', e.target.value)} />
                                                    </div>
                                                    <div className="w-100">
                                                        <input type="text" className="form-control" placeholder="Keywords" value={categoryKeywords} onChange={(e) => handleCategoryChange('keywords', e.target.value)} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-12 col-md-4 col-form-label">Sub Category</label>
                                                <div className="col-12 col-md-8">
                                                    {subcategories.map((sub, i) => (
                                                        <div className="subcategory_div1 mb-3" key={i}>
                                                            <div className="subcategory_div align-items-center">
                                                                <div className="col-10 col-md-10">
                                                                    <div className="mb-2 w-100">
                                                                        <input type="text" className="form-control" placeholder="Sub Category Name" value={sub.name} onChange={(e) => handleSubcategoryChange(i, 'name', e.target.value)} />
                                                                    </div>
                                                                    <div className="w-100">
                                                                        <input type="text" className="form-control" placeholder="Keywords" value={sub.keywords} onChange={(e) => handleSubcategoryChange(i, 'keywords', e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-2 col-md-2 text-center">
                                                                    {i === subcategories.length - 1 ? (
                                                                        <i className="fa-solid fa-circle-plus f_sz20 crsr_pntr" onClick={addSubcategory}></i>
                                                                    ) : (
                                                                        <i className="fa-solid fa-trash-can f_sz18 f_red crsr_pntr" onClick={() => removeSubcategory(i)}></i>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="add_childcat mt-3">
                                                                {!sub.showChildren && (
                                                                    <div className="addchildcat_txt addchildcat_clk crsr_pntr" onClick={() => addChild(i)}>Add Child Category</div>
                                                                )}
                                                            </div>

                                                            {sub.showChildren && (
                                                                <div className="child_category1 w-100">
                                                                    {sub.children.map((child, j) => (
                                                                        <div className="subcategory_div align-items-center mb-4" key={j}>
                                                                            <div className="col-10 col-md-10">
                                                                                <div className="mb-2 w-100">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder="Child Category Name"
                                                                                        value={child.name}
                                                                                        onChange={(e) => handleChildChange(i, j, 'name', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                <div className="w-100">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder="Keywords"
                                                                                        value={child.keywords}
                                                                                        onChange={(e) => handleChildChange(i, j, 'keywords', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-2 col-md-2 text-center">
                                                                                <i
                                                                                    className="fa-solid fa-trash-can f_sz18 f_red crsr_pntr mr-2"
                                                                                    onClick={() => removeChild(i, j)}
                                                                                ></i>
                                                                                <i
                                                                                    className="fa-solid fa-circle-plus f_sz20 crsr_pntr"
                                                                                    onClick={() => addChildAt(i, j + 1)}
                                                                                ></i>
                                                                            </div>
                                                                        </div>
                                                                    ))}

                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card-footer text-center">
                                            <button type="submit" className="btn btn-blue">Add</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Category_Add;
